import { c as _c } from "react/compiler-runtime";
import { twMerge } from 'tailwind-merge';
type CardHeaderProps = {
  className?: string;
  children: React.ReactNode;
};
export function CardHeader(t0) {
  const $ = _c(5);
  const {
    className,
    children
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = twMerge("flex justify-between px-4 pt-3 pb-2 font-semibold antialiased", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <div className={t1}>{children}</div>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}